// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__XS+97","nav":"Footer_nav__mdfgU","link":"Footer_link__WJUSh","developer":"Footer_developer__7qPyw"};